import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";
import { useCursorOn } from "@/lib/cursorPref";

export const Cursor = () => {
  const [fine, setFine] = useState(false);
  const cursorOn = useCursorOn();
  const [active, setActive] = useState(false);
  const [down, setDown] = useState(false);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 500, damping: 40, mass: 0.5 });
  const sy = useSpring(y, { stiffness: 500, damping: 40, mass: 0.5 });

  useEffect(() => {
    if (window.matchMedia("(pointer: fine)").matches) setFine(true);
  }, []);

  useEffect(() => {
    if (!fine) return;
    if (!cursorOn) {
      document.documentElement.classList.remove("stax-cursor");
      return;
    }
    document.documentElement.classList.add("stax-cursor");
    const move = (e) => { x.set(e.clientX); y.set(e.clientY); };
    const over = (e) =>
      setActive(!!e.target.closest("a,button,select,input,textarea,label,[role='button']"));
    const dn = () => setDown(true);
    const up = () => setDown(false);
    window.addEventListener("mousemove", move, { passive: true });
    window.addEventListener("mouseover", over, { passive: true });
    window.addEventListener("mousedown", dn);
    window.addEventListener("mouseup", up);
    return () => {
      document.documentElement.classList.remove("stax-cursor");
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
      window.removeEventListener("mousedown", dn);
      window.removeEventListener("mouseup", up);
    };
  }, [fine, cursorOn, x, y]);

  if (!fine || !cursorOn) return null;

  return (
    <motion.div
      data-testid="circle-cursor"
      aria-hidden="true"
      className="pointer-events-none fixed left-0 top-0 z-[200]"
      style={{ x: sx, y: sy }}
    >
      <motion.div
        animate={{ scale: down ? 0.7 : active ? 1.55 : 1 }}
        transition={{ duration: 0.18, ease: "easeOut" }}
        className="relative -translate-x-1/2 -translate-y-1/2"
        style={{ width: 34, height: 30 }}
      >
        <span className="absolute rounded-full mix-blend-multiply" style={{ width: 20, height: 20, background: "var(--sy)", left: 0, top: 0 }} />
        <span className="absolute rounded-full mix-blend-multiply" style={{ width: 18, height: 18, background: "var(--sc)", left: 13, top: 2 }} />
        <span className="absolute rounded-full mix-blend-multiply" style={{ width: 18, height: 18, background: "var(--sm)", left: 6, top: 12 }} />
      </motion.div>
    </motion.div>
  );
};
